import {OnInit, OnDestroy, Directive, input, inject, computed, Signal} from '@angular/core';
import {TaAppStore} from '../../../state/clcta-store';
import {FullTaDetails} from '../../../api';
import {TaSubmissionDatasource} from '../../../datasources/ta-submission.datasource';
import {TaSearchDatasource} from '../../../datasources/ta-search-datasource';
import {Router} from '@angular/router';
import {CreateTaStepType, isFlightOnlyTa} from '../../../util/app.types';

@Directive()
export abstract class CreateTaBaseComponent implements OnInit, OnDestroy {
  isReadOnly = input<boolean>(false);
  store = inject(TaAppStore)
  taSearchDatasource: TaSearchDatasource = inject(TaSearchDatasource);
  taSubmissionDatasource: TaSubmissionDatasource = inject(TaSubmissionDatasource);
  router = inject(Router);

  readonly taSubmission: Signal<FullTaDetails | undefined> = this.store.taSubmission
  isFlightOnly = computed<boolean>(() => isFlightOnlyTa(this.taSubmission()));

  //Computed data signals
  startDate = computed<Date | null>(() => {
    const date = new Date(this.store.taSubmission()?.startDate ?? '');
    if (!!(date) && !isNaN(date.getTime())) {
      return date;
    }
    return null
  });
  endDate = computed<Date | null>(() => {
    const date = new Date(this.store.taSubmission()?.endDate ?? '');
    if (!!(date) && !isNaN(date.getTime())) {
      return date;
    }
    return null
  });
  maxDate = computed<Date | null>(() => {
    if (!!this.endDate()) {
      let date = new Date(this.endDate()!);
      date.setHours(23);
      date.setMinutes(59);
      return date;
    }
    return null;
  });
  maxItineraryItems = computed<number | null>(() => {
    const msPerDay = 1000 * 60 * 60 * 24;
    const start = this.startDate();
    const max = this.maxDate();
    if (start && max) {
      return Math.ceil((max.getTime() - start.getTime()) / msPerDay)
    }
    return null;
  });
  sortedTravellers = computed(() => {
    const primaryId = this.store.taSubmission()?.primaryTraveller?.travellerId;
    return [...(this.taSubmission()?.travellers ?? [])].sort((t1, t2) => {
      if (t1.travellerId === primaryId) return -1;
      if (t2.travellerId === primaryId) return 1;
      if (!t1.details?.surname && !t2.details?.surname) return 0;
      if (!t1.details?.surname) return 1;
      if (!t2.details?.surname) return -1;
      return t1.details.surname.localeCompare(t2.details.surname);
    });
  });


  constructor() {}

  // Lifecycle hooks
  ngOnInit(): void {
    // console.log('CreateTaBaseComponent INIT');
  }

  ngOnDestroy(): void {
    // console.log('CreateTaBaseComponent ONDESTROY');
  }


}
